import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/AppLayout";
import { EligibilityCheck } from "@/components/funding/EligibilityCheck";
import { BankPackage } from "@/components/funding/BankPackage";
import { PitchPackage } from "@/components/funding/PitchPackage";
import { TopIndustries } from "@/components/funding/TopIndustries";

export default function FundingReadiness() {
  return (
    <div>
      <PageHeader eyebrow="Funding Readiness" title="Can I open this, and can I fund it?">Check the owner credentials, licenses and permits your business needs, close the gaps with a step-by-step plan, then turn proven compliance into a lender-ready package.</PageHeader>
      <Tabs defaultValue="check">
        <TabsList className="mb-6 max-w-full overflow-x-auto justify-start">
          <TabsTrigger value="check" data-testid="funding-tab-check">Can I open this?</TabsTrigger>
          <TabsTrigger value="bank" data-testid="funding-tab-bank">Bank / SBA package</TabsTrigger>
          <TabsTrigger value="crowd" data-testid="funding-tab-crowd">Crowdfunding kit</TabsTrigger>
          <TabsTrigger value="sponsor" data-testid="funding-tab-sponsor">Sponsorship pitch</TabsTrigger>
          <TabsTrigger value="top" data-testid="funding-tab-top">Top grant industries</TabsTrigger>
        </TabsList>
        <TabsContent value="check"><EligibilityCheck /></TabsContent>
        <TabsContent value="bank"><BankPackage /></TabsContent>
        <TabsContent value="crowd"><PitchPackage track="crowdfunding" /></TabsContent>
        <TabsContent value="sponsor"><PitchPackage track="sponsorship" /></TabsContent>
        <TabsContent value="top"><TopIndustries /></TabsContent>
      </Tabs>
    </div>
  );
}
